export default class Organization {
	constructor({ id, name, has_cashless_config } = {}) {
		this._id = id;
		this._name = name;
		this._has_cashless_config = has_cashless_config;
	}

	id() {
		return this._id;
	}

	name() {
		return this._name || "";
	}

	hasCashlessConfig() {
		return this._has_cashless_config;
	}
}
